module.exports = __webpack_public_path__ + "static/media/spi.7c992f84.png";